var style = {"z-radio-card-group":"z-radio-card-group","z-radio-card":"z-radio-card"};

export { style as default };
//# sourceMappingURL=RadioCardGroup.module.scss.js.map
